export default __webpack_public_path__ + "static/media/rolands-admidins-offer-bottom.6dd85123.png";